import type { VehicleCard } from "../types/api"

/**
 * Neutral visual shell used only for an active Garage that currently has no
 * vehicle attached. Inactive users use the real persisted A000AA000 demo card.
 */
export const GARAGE_PREVIEW_VEHICLE: VehicleCard = {
  id: -1,
  plate_raw: "A000AA000",
  plate_normalized: "A000AA000",
  plate_display: "А 000 АА 000",
  country_code: "RU",
  display_views: 99000,
  real_search_count: 0,
  has_garage: false,
  garage_is_active: false,
  garage_owner_activity: null,
  is_owner_viewing: false,
  current_status: null,
  signal_counters: [],
  card_share_count: 0,
}
